import SellerInboundGenderBadge from 'domains/seller-inbound/atoms/gender-badge'
import SellerInboundDeliveryMethodBadge from 'domains/seller-inbound/atoms/delivery-method-badge'
import SellerBadge from 'domains/seller/atoms/seller-badge'
import SellerInboundCurationStatusBadge from 'domains/seller-inbound/atoms/curation-status-badge'
import SellerInboundLiveProcessStatusBadge from 'domains/seller-inbound/atoms/live-process-status-badge'
import SellerInboundConfirmationStatusBadge from 'domains/seller-inbound/atoms/confirmation-status-badge'
import SellerInboundReceivedStatusBadge from 'domains/seller-inbound/atoms/received-status-badge'
import SellerInboundPickupScheduledBadge from 'domains/seller-inbound/atoms/pickup-scheduled-badge'
import TimeUtil from 'utils/time-util'
import ProductBrandClassificationBadge from 'domains/product-brand/atoms/classification-badge/product-brand-classification-badge'

const SellerInboundUrlParamsTableCellService = {
  /**
   * Generate cell content for SellerInboundUrlParamsTable
   * @param {object} inbound - Seller::Inbound data
   */
  generateInboundCellData: (inbound) => {
    const pickup   = inbound.pickup
    const notes    = inbound.notes
    const curation = inbound.curation

    return {
      'code': {
        content: inbound.code
      },
      'tl_brand_classification': {
        content: <ProductBrandClassificationBadge classification={ inbound.tl_brand_classification }/>
      },
      'gender': {
        content: <SellerInboundGenderBadge gender={ inbound.gender } />
      },
      'delivery_method': {
        content: <SellerInboundDeliveryMethodBadge delivery_method={ inbound.delivery_method } />
      },
      'dropoff_location': {
        content: inbound.dropoff_location ? inbound.dropoff_location.toUpperCase() : '-'
      },
      'requested_date': {
        content: TimeUtil.format(inbound.requested_date)
      },
      'confirmation_status': {
        content: <SellerInboundConfirmationStatusBadge confirmation_status={ inbound.confirmation_status } />
      },
      'received_status': {
        content: <SellerInboundReceivedStatusBadge received_status={ inbound.received_status } />
      },
      'live_process_status': {
        content: <SellerInboundLiveProcessStatusBadge live_process_status={ inbound.live_process_status } />
      },
      'quantity': {
        content: inbound.quantity
      },
      'received_quantity': {
        content: inbound.received_quantity
      },
      'received_date': {
        content: TimeUtil.format(inbound.inbound_request?.received_at)
      },
      'pickup_scheduled': {
        content: <SellerInboundPickupScheduledBadge scheduled={ pickup?.scheduled } />
      },
      'pickup_scheduled_date': {
        content: pickup ? TimeUtil.format(pickup.scheduled_at) : '-'
      },
      'seller_name': {
        content: inbound.seller.name
      },
      'seller_code': {
        content: inbound.seller.code
      },
      'seller_email': {
        content: inbound.seller.email
      },
      'seller_phone': {
        content: inbound.seller.mobile
      },
      'notes': {
        content : notes ? notes.note : '-',
        style   : {
          minWidth   : 400,
          whiteSpace : 'break-spaces'
        }
      },
      'seller_type': {
        content: <SellerBadge seller_type={ inbound.seller.seller_type } />
      },
      'curation_status': {
        content: <SellerInboundCurationStatusBadge curation_status={ inbound.curation_status } />
      },
      'curation_curated_date': {
        content: curation ? TimeUtil.format(curation.curated_date) : '-'
      },
      'curation_accepted_total': {
        content: curation?.accepted_total || 0
      },
      'curation_rejected_total': {
        content: curation?.rejected_total || 0
      }
    }
  }

}

export default SellerInboundUrlParamsTableCellService